import React, { useState, useRef } from "react";
import useAxios from "../useAxios";
import useSessionStorage from "../useSessionStorage";
import Modal from "../Modal";
import "../FormStyles.css";

const PlayerDisplay = ({ player, onPlayerUpdated, gameTypeId }) => {
  const [axios] = useAxios(true);
  const [tenant] = useSessionStorage("tenant");
  const modalRef = useRef();

  const [editPlayer, setEditPlayer] = useState(null);
  const [tenants, setTenants] = useState([]);

  const handleIconClick = async () => {
    // Fetch the latest player data
    await axios.get("player/" + player.id, (playerData) => {
      setEditPlayer(playerData);
    });

    // Fetch tenants if user is super admin
    if (tenant?.super) {
      await axios.get("tenants", setTenants);
    }

    modalRef.current?.open();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditPlayer((prev) => ({ ...prev, [name]: value }));
  };

  const handleHandicapChange = (e) => {
    const { value } = e.target;
    const handicapValue = parseInt(value) || 0;

    setEditPlayer((prev) => {
      const updatedHandicaps = [...(prev.handicaps || [])];
      const existingIndex = updatedHandicaps.findIndex(h => h.gameTypeId === gameTypeId);

      if (existingIndex >= 0) {
        // Update existing handicap
        updatedHandicaps[existingIndex] = {
          ...updatedHandicaps[existingIndex],
          value: handicapValue
        };
      } else if (gameTypeId) {
        // Add new handicap for this game type
        updatedHandicaps.push({
          gameTypeId: gameTypeId,
          value: handicapValue
        });
      }

      return { ...prev, handicaps: updatedHandicaps };
    });
  };

  // Get the handicap value for the current game type
  const getHandicapValue = () => {
    if (!editPlayer || !gameTypeId) return 0;
    const handicap = (editPlayer.handicaps || []).find(h => h.gameTypeId === gameTypeId);
    return handicap?.value ?? 0;
  };

  const handleTenantChange = (e) => {
    const { value } = e.target;
    const selectedTenant = tenants.find((t) => t.id === value);
    setEditPlayer((prev) => ({ ...prev, tenant: selectedTenant }));
  };

  const handleSave = () => {
    const payload = { ...editPlayer };
    if (tenant?.super) {
      payload.tenant = tenants.find((t) => t.id === editPlayer.tenant?.id);
    } else {
      payload.tenant = tenant;
    }

    axios.post("player/" + editPlayer.id, payload, () => {
      modalRef.current?.close();
      // Notify parent component that player was updated
      if (onPlayerUpdated) {
        onPlayerUpdated(editPlayer);
      }
    });
  };

  const handleCancel = () => {
    modalRef.current?.close();
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <button
          type="button"
          onClick={handleIconClick}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "2px",
            display: "flex",
            alignItems: "center",
            fontSize: "16px",
            color: "#007bff",
          }}
          title="Edit player"
        >
          ✏️
        </button>
        <span>{player.name}</span>
      </div>

      <Modal ref={modalRef} size="medium" canClose={false}>
        {editPlayer && (
          <div style={{ padding: "20px" }}>
            <h2>Edit Player</h2>
            <form className="player-form-fields">
              {tenant?.super && (
                <div className="form-group">
                  <label htmlFor="tenant">Tenant:</label>
                  <select
                    name="tenant"
                    id="tenant"
                    value={editPlayer.tenant?.id || ""}
                    onChange={handleTenantChange}
                    required
                    className="form-control"
                  >
                    <option value="">Select a tenant</option>
                    {tenants.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={editPlayer.name}
                  onChange={handleChange}
                  required
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="handicap">Handicap:</label>
                <input
                  type="number"
                  name="handicap"
                  id="handicap"
                  value={getHandicapValue()}
                  onChange={handleHandicapChange}
                  min={0}
                  max={100}
                  required
                  className="form-control"
                />
              </div>
              <div className="form-buttons" style={{ flexDirection: "row", gap: "8px", justifyContent: "flex-end" }}>
                <button
                  type="button"
                  onClick={handleSave}
                  className="submit-button"
                  style={{ height: "36px", minWidth: "80px", padding: "8px 16px" }}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={handleCancel}
                  className="cancel-button"
                  style={{ height: "36px", minWidth: "80px", padding: "8px 16px" }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}
      </Modal>
    </>
  );
};

export default PlayerDisplay;
